module.exports = __webpack_public_path__ + "img/type-manage.e1bc3b00.png";